// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"MultiCheckboxFilter_checkboxContainer__lb6EX"};